import React from "react";
import { Grid, MenuItem } from "@material-ui/core";
import C1InputField from "app/c1component/C1InputField";
import C1SelectField from "app/c1component/C1SelectField";
import { countryList } from "app/sctcomponent/SctConstant";

const fieldInputProps = (maxLength, placeHolder) => ({ maxLength, placeHolder });

const TraderDetail = ({
    inputData,
    handleInputChange,
    handleInputChangeDeep,
    isDisabled,
    errors,
}) => {
    const accnTypes = [
        { value: "ACC_TYPE_RAEO_OPERATOR", desc: "Trader / Economic Operator" }
    ];
    const handleInputChangeDeepWrap = (e) => {
        handleInputChangeDeep(e.target.name, e.target.value);
    };

    const handleInputChangeContactNo = (e) => {
        const inputValue = e.target.value || "";
        const numericValue = inputValue.replace(/[^\d]/g, '');
        handleInputChange({ target: { name: 'accnrTel', value: numericValue } });
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
                {/* <C1SelectField
                    label="Account Type"
                    name="TMstAccnType.atypId"
                    required
                    disabled={isDisabled}
                    onChange={handleInputChangeDeepWrap}
                    value={inputData.TMstAccnType?.atypId || ""}
                    optionsMenuItemArr={
                        accnTypes.map((item, ind) => (
                            <MenuItem value={item.value} key={ind}>{item.desc}</MenuItem>
                        ))}
                    error={errors['TMstAccnType'] !== undefined}
                    helperText={errors['TMstAccnType'] || ''}
                /> */}
                <C1SelectField
                    label="Account Type"
                    name="TMstAccnType.atypId"
                    required
                    disabled={true}
                    onChange={handleInputChangeDeepWrap}
                    value={inputData.TMstAccnType?.atypId || "ACC_TYPE_RAEO_OPERATOR"}
                    optionsMenuItemArr={[
                        <MenuItem value="ACC_TYPE_RAEO_OPERATOR" key="ACC_TYPE_RAEO_OPERATOR">
                            Trader / Economic Operator
                        </MenuItem>
                    ]}
                    error={errors['TMstAccnType'] !== undefined}
                    helperText={errors['TMstAccnType'] || ''}
                />
                <C1InputField
                    label="TIN No."
                    name="accnrCompReg"
                    disabled={isDisabled}
                    required
                    inputProps={fieldInputProps(35, 'Enter tax identification number')}
                    onChange={handleInputChange}
                    value={inputData.accnrCompReg || ""}
                    error={errors['accnrCompReg'] !== undefined}
                    helperText={errors['accnrCompReg'] || ''}
                />
                <C1InputField
                    label="Contact No"
                    name="accnrTel"
                    disabled={isDisabled}
                    required
                    inputProps={fieldInputProps(35, '+251 9XX XXX XXX')}
                    onChange={handleInputChangeContactNo}
                    value={inputData.accnrTel || ""}
                    error={errors['accnrTel'] !== undefined}
                    helperText={errors['accnrTel'] || ''}
                />
                <C1InputField
                    label="Province"
                    name="accnrProv"
                    disabled={isDisabled}
                    required
                    inputProps={fieldInputProps(30, 'Select province')}
                    onChange={handleInputChange}
                    value={inputData.accnrProv || ""}
                    error={errors['accnrProv'] !== undefined}
                    helperText={errors['accnrProv'] || ''}
                />
                <C1InputField
                    label="Postal Code"
                    name="accnrPcode"
                    disabled={isDisabled}
                    required={false}
                    inputProps={fieldInputProps(10, 'Enter postal code')}
                    onChange={handleInputChange}
                    value={inputData.accnrPcode || ""}
                    error={errors['accnrPcode'] !== undefined}
                    helperText={errors['accnrPcode'] || ''}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <C1InputField
                    label="Company Name"
                    name="accnrCompName"
                    disabled={isDisabled}
                    required
                    inputProps={fieldInputProps(128, 'Enter registered company name')}
                    onChange={handleInputChange}
                    value={inputData.accnrCompName || ""}
                    error={errors['accnrCompName'] !== undefined}
                    helperText={errors['accnrCompName'] || ''}
                />
                <C1InputField
                    label="Company Email Address"
                    name="accnrEmail"
                    disabled={isDisabled}
                    required
                    inputProps={fieldInputProps(128, 'name@company.com')}
                    onChange={handleInputChange}
                    value={inputData.accnrEmail || ""}
                    error={errors['accnrEmail'] !== undefined}
                    helperText={errors['accnrEmail'] || ''}
                />
                <C1InputField
                    label="Address Line 1"
                    name="accnrAddressLine1"
                    disabled={isDisabled}
                    required
                    inputProps={fieldInputProps(64, 'Street address')}
                    onChange={handleInputChange}
                    value={inputData.accnrAddressLine1 || ""}
                    error={errors['accnrAddressLine1'] !== undefined}
                    helperText={errors['accnrAddressLine1'] || ''}
                />
                <C1InputField
                    label="City / District"
                    name="accnrCity"
                    disabled={isDisabled}
                    required
                    inputProps={fieldInputProps(30, 'Select city or district')}
                    onChange={handleInputChange}
                    value={inputData.accnrCity || ""}
                    error={errors['accnrCity'] !== undefined}
                    helperText={errors['accnrCity'] || ''}
                />
                <C1SelectField
                    label="Country"
                    name="TMstCountry.ctyCode"
                    required
                    disabled={isDisabled}
                    onChange={handleInputChangeDeepWrap}
                    value={inputData.TMstCountry?.ctyCode || ""}
                    optionsMenuItemArr={countryList.map((item, ind) => (
                        <MenuItem value={item.value} key={ind}>{item.desc}</MenuItem>
                    ))}
                    error={errors['TMstCountry'] !== undefined}
                    helperText={errors['TMstCountry'] || ''}
                />
            </Grid>
        </Grid>
    );
};

export default TraderDetail;
